import { CityViewModel } from '@common/model/location/cityViewModel';
import { CITY_SEARCH_FORM_FIELD_NAME_DEFAULT } from '@cp/entities/location';
import { FormModel } from '../form';

export const getDefaultValues = (defaultCity: CityViewModel | undefined): FormModel => {
  const formValues: FormModel = {
    [CITY_SEARCH_FORM_FIELD_NAME_DEFAULT]: defaultCity,
  };

  return formValues;
};
